import { useMemo } from 'react';
import { Button } from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import config from '../../config';

const PLACEHOLDER_CARDS = Array.from({ length: 7 }, (_, index) => ({ _id: `placeholder-${index}` }));

export function NoSubscribeLikeList({ notifications = [] }) {
  const navigate = useNavigate();

  const likedUsers = useMemo(() => {
    const uniqueUsers = new Map();

    notifications.forEach((notification) => {
      if (notification?.type !== 'like') return;

      const user = notification?.payload;
      if (!user?._id || uniqueUsers.has(user._id)) return;

      uniqueUsers.set(user._id, user);
    });

    return Array.from(uniqueUsers.values());
  }, [notifications]);

  const cards = likedUsers.length > 0 ? likedUsers : [];


  const handleOpenPremium = () => {
    navigate(config.ROUTES.PREMIUM);
  };

  return (
    <div className="w-[100vw] flex justify-center items-start relative pb-[220px]">
      <div className="w-full px-4 text-white grid grid-cols-2 gap-[16px]">
        {cards.map((user) => (
          <div key={user._id} className="relative w-full h-[220px] overflow-hidden rounded-[24px]">
            {user.photo ? (
              <img
                src={user.photo}
                alt={user.name || 'Лайкнувший пользователь'}
                className="w-full h-[220px] object-cover blur-[14px] scale-[1.08]"
                onErrorCapture={(e) => {
                  console.log('onErrorCapture', e);
                  e.target.src = "/mock/user_1/user_1_match.png"
                }}
              />
            ) : (
              <img src="/icons/like_locked.png" alt="locked like" className="w-full h-[220px]" />
            )}

            {user.photo && (
              <>
                <div className="absolute inset-0 bg-black/10 backdrop-blur-[1px]" />
                <img src="/icons/heart-w.svg" alt="locked like" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 size-10 z-[5]" />
              </>
            )}
          </div>
        ))}
      </div>
      <div onClick={handleOpenPremium} className="fixed bottom-[135px] w-full flex justify-center">
        <Button>Хочу узнать, кто меня лайкнул</Button>
      </div>
    </div>
  );
}
